var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-fill"},[(_vm.loadingImages)?_c('v-container',{staticClass:"d-flex align-center justify-center"},[_c('platform-spinner',{attrs:{"color":"primary","size":50,"width":5}})],1):_c('div',{staticClass:"d-flex flex-row"},[_c('display-markdown',{attrs:{"value":_vm.markdownContent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }